'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "months" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/months.js
// module id = 866
// module chunks = 0